module.exports = __webpack_public_path__ + "img/Impact identification-Impact definition.81905c7b.svg";